/**
 * Preview construction — page descriptors, not page contents.
 *
 * The import screen renders one page at a time. Handing it the whole document
 * a second time under another name would mean walking 5,000 elements to draw a
 * page switcher, so the preview carries counts and labels only. Anything that
 * needs actual elements reads `ParseResult.document`.
 */

/**
 * @param {Object} document
 * @returns {import('./types').Preview}
 */
export const buildPreview = (document) => {
  const doc = document || {};
  const pages = Array.isArray(doc.pages) ? doc.pages : [];

  return {
    canvas: {
      width: Number.isFinite(doc.canvas_width) ? doc.canvas_width : 0,
      height: Number.isFinite(doc.canvas_height) ? doc.canvas_height : 0,
    },
    pageCount: pages.length,
    pages: pages.map((page, i) => ({
      id: page && page.id ? page.id : `page-${i + 1}`,
      name: page && page.name ? page.name : `Page ${i + 1}`,
      background: page && typeof page.background === 'string' ? page.background : '#ffffff',
      elementCount: page && Array.isArray(page.elements) ? page.elements.length : 0,
    })),
  };
};
